import React from 'react';
import { ScheduleTable } from '../../components/ScheduleTable';
export function ScheduleTableBlock() {
  return <ScheduleTable data-id="element-2967" />;
}